var avatarFallback = 'fx_b722dd09_cp0sj71';
var avatarFallbackBackground = 'var(--fx_b722dd09_cp0sj70)';

export { avatarFallback, avatarFallbackBackground };
//# sourceMappingURL=fallback.vanilla.mjs.map
